import { useSelector } from "react-redux";
import { selectUser } from "../../../core/data/redux/slice/user";
import TeacherDashboard from "../teacherDashboard";
import StudentDasboard from "../studentDashboard";
import ParentDashboard from "../parentDashboard";
import AdminDashboard from "../adminDashboard";
import { SYSTEM_ROLES } from "../../../constant";

const Dashboard = () => {
  const user = useSelector(selectUser);
  if (user.role.name === SYSTEM_ROLES.teacher) {
    return <TeacherDashboard />;
  }
  if (user.role.name === SYSTEM_ROLES.student) {
    return <StudentDasboard />;
  }
  if (user.role.name === SYSTEM_ROLES.parent) {
    return <ParentDashboard />;
  }
  return <AdminDashboard />;
};

export default Dashboard;
